export function getDaysBetweenDates(startDate, endDate, subType) {
  const d1 = new Date(startDate);
  const d2 = new Date(endDate);

  // total days inclusive
  const diffInMs = Math.abs(d2.getTime() - d1.getTime());
  const dayDiff = Math.floor(diffInMs / (1000 * 60 * 60 * 24)) + 1;

  const isSameDay = dayDiff === 1;

  // -------------------
  // SAME DAY RULES
  // -------------------
  if (isSameDay) {
    switch (subType) {
      case "first_half":
      case "second_half":
        return 0.5;

      case "short_leave":
        return 0.25;

      case "full_day":
      default:
        return 1;
    }
  }

  // -------------------
  // MULTI-DAY RULES
  // -------------------

  // full day simply = full count
  if (subType === "full_day") {
    return dayDiff;
  }

  // half-day → 0.5 for first day + full days for rest
  if (subType === "first_half" || subType === "second_half") {
    // Example: 3 days → 0.5 + 2 = 2.5
    return 0.5 + (dayDiff - 1);
  }

  // short leave across multiple days → full count (or change if needed)
  if (subType === "short_leave") {
    return dayDiff;
  }

  return dayDiff;
}
